import { render } from "./LibraryColorwayPreviewSelect.vue?vue&type=template&id=a87f7b8c&scoped=true"
import script from "./LibraryColorwayPreviewSelect.vue?vue&type=script&lang=js"
export * from "./LibraryColorwayPreviewSelect.vue?vue&type=script&lang=js"

import "./LibraryColorwayPreviewSelect.vue?vue&type=style&index=0&id=a87f7b8c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87f7b8c"]])

export default __exports__